import { store } from "~/state/store";

export function getUserEmail() {
	const { user } = store.getState().user;

	return user.state === "green" && !user.phoneOnly
		? user.username
		: "";
}
